import(/* webpackMode: "eager" */ "/home/ubuntu/html/tablespace-website/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["GtmScript","GtmNoScript","Analytics","ClarityScript"] */ "/home/ubuntu/html/tablespace-website/components/Analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatWidget"] */ "/home/ubuntu/html/tablespace-website/components/ChatWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CmsEditMode"] */ "/home/ubuntu/html/tablespace-website/components/CmsEditMode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorLogger"] */ "/home/ubuntu/html/tablespace-website/components/ErrorLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/ubuntu/html/tablespace-website/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/ubuntu/html/tablespace-website/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HubSpotScript"] */ "/home/ubuntu/html/tablespace-website/components/HubSpotScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteTracker"] */ "/home/ubuntu/html/tablespace-website/components/SiteTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackingScripts"] */ "/home/ubuntu/html/tablespace-website/components/TrackingScripts.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/html/tablespace-website/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Outfit\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-outfit\",\"display\":\"swap\"}],\"variableName\":\"outfit\"}");
